import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Counter from "@/Sections/Counter";
import BeforeAfter from "@/Sections/BeforeAfter";
import About from "@/Sections/About";
import Contact from "@/Sections/Contact";
import Features from "@/Sections/Features";
import { Link, animateScroll as scroll } from "react-scroll";
import Spotify from "@/Components/Spotify";
import Listen from "@/Sections/Listen";

export default function Home() {
    return (
        <Default>
            <Head>
                <title>Personal training Uden en Schijndel</title>
                <link rel="canonical" href={route("home")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta property="og:url" content={route("home")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Home - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={true}>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl">
                        Personal training <br /> Uden en Schijndel
                    </h1>
                    <div className="text-center xs:pt-4 sm:pt-4 md:pt-8 lg:pt-16">
                        <a
                            href={route("results")}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Bekijk hier de resultaten!
                        </a>
                    </div>
                </Hero>
                <Counter />

                {/* Proud */}
                {/* <div className="relative py-8">
                    <div className="text-center">
                        <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are</span>
                        </p>
                        <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl sm:text-5xl">
                            Proud
                        </h2>
                        <p className="max-w-2xl mt-5 mx-auto text-xl text-gray-100">
                            Dit jaar zijn we bekroond met de Dutch Fitness
                            Awards. We hebben gewonnen in de categorie personal
                            trainers. We zijn trots op deze prestatie en willen
                            iedereen bedanken die op ons heeft gestemd.
                        </p>
                    </div>
                    <img
                        src="/assets/home/award.jpg"
                        className="h-96 items-center text-center mx-auto mt-6"
                    />
                </div> */}

                <BeforeAfter />

                <Features />

                <div className="flex justify-center items-center max-w-4xl mx-auto my-8">
                    <img
                        src="/assets/nieuwe-standaard-3.jpg"
                        className="rounded-2xl"
                    />
                </div>

                <About />

                <Spotify />

                <Contact />
            </div>
        </Default>
    );
}
